<template>
  <main>
    <form class="container" @submit.prevent="save">
      <div class="row">
        <div class="col-full heading-xl">
          <h1 class="margin-bottom-md">
            {{ $t('contactInformation.heading') }}
          </h1>
          <p class="heading-md margin-bottom-xs">
            {{ $t('common.userId') }}:
            <span data-test="user-id-string" class="p">{{ email }}</span>
          </p>
          <p class="heading-md margin-bottom-xl">
            {{ $t('common.mobileNumber') }}:
            <span data-test="mobile-number-string" class="p">{{ mobileNumber }}</span>
          </p>
          <i18n :path="'contactInformation.supportNotice'" tag="p" class="legal">
            <a :href="customerServiceContact.href" place="customerServiceNumber">{{
              customerServiceContact.val
            }}</a>
          </i18n>
        </div>
      </div>

      <div class="row row-vertical-align-bottom">
        <div class="col-full align-center">
          <back-button v-analytics:click="$EVENTS.GO_BACK_BUTTON" :location="backButtonRoute">
            {{ $t('button.goBack') }}
          </back-button>
        </div>
      </div>
    </form>
  </main>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BackButton from '@/components/BackButton'
import { ROUTES } from '@/constants'

export default {
  name: ROUTES.CONTACT_INFORMATION_SUPPORT,
  components: { BackButton },
  data() {
    return {
      backButtonRoute: { name: ROUTES.CONTACT_INFORMATION_SETTINGS }
    }
  },
  computed: {
    ...mapState({
      currentCountry: (state) => state.user.consumer.countryCode
    }),
    ...mapGetters(['formattedUserEmail', 'formattedUserMobileNumber']),
    email() {
      return this.formattedUserEmail
    },
    mobileNumber() {
      return this.formattedUserMobileNumber(this)
    },
    customerServiceContact() {
      const countryConfig = this.$i18nData.getCountryConfig(this.currentCountry)
      const phoneNumber = countryConfig?.customerSupportPhoneNumber || ''

      return {
        href: `tel:${phoneNumber}`,
        val: phoneNumber
      }
    }
  }
}
</script>
